(function init() {
    var menuToggle = document.querySelector('.menu .menu-toggle');

    // DOM not ready yet � wait and retry
    if (!menuToggle) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', init);
        }
        return;
    }

    var menu = menuToggle.closest('.menu');

    // 1. Toggle the category dropdown on filter button click
    menuToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        menu.classList.toggle('open');
        var expanded = menuToggle.getAttribute('aria-expanded') === 'true';
        menuToggle.setAttribute('aria-expanded', String(!expanded));
    });

    // 2. Close dropdown when clicking outside
    document.addEventListener('click', function (e) {
        if (!menu.contains(e.target)) {
            menu.classList.remove('open');
            menuToggle.setAttribute('aria-expanded', 'false');
        }
    });

    // 3. Hide filter bar when header overlay opens, restore when it closes
    var observer = new MutationObserver(function () {
        var overlayOpen = document.body.classList.contains('overlay-in');
        if (overlayOpen) {
            menu.classList.add('d-none');
            menu.classList.remove('open');
            menuToggle.setAttribute('aria-expanded', 'false');
        } else {
            menu.classList.remove('d-none');
        }
    });

    observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
    });
})();